import {
  Users,
  Cube,
  Cog,
  Truck,
  Beaker,
  Trash,
} from "../../../../../components/icons/svg/outline";
import {
  getWorkers,
  getMaterials,
  getEquipment,
  getMixDesigns,
  getSubcontractors,
  getDumping,
  getUnits,
} from "../../../../../services/api/tmlog";

// Line item type configurations
export const LINE_ITEM_TYPES = {
  labor: {
    label: "Labor",
    icon: Users,
    bgColor: "bg-blue-50",
    defaultUnit: "Hours",
    units: ["Hours"],
    fetchOptions: getWorkers,
  },
  material: {
    label: "Material",
    icon: Cube,
    bgColor: "bg-green-50",
    defaultUnit: "Count",
    units: getUnits,
    fetchOptions: getMaterials,
  },
  equipment: {
    label: "Equipment",
    icon: Cog,
    bgColor: "bg-yellow-50",
    defaultUnit: "Hours",
    units: ["Hours"],
    fetchOptions: getEquipment,
  },
  subcontractors: {
    label: "Subcontractors",
    icon: Truck,
    bgColor: "bg-purple-50",
    defaultUnit: "Count",
    units: ["Count"],
    fetchOptions: getSubcontractors,
  },
  dumping: {
    label: "Dumping",
    icon: Trash,
    bgColor: "bg-amber-50",
    defaultUnit: "Count",
    units: ["Count"],
    fetchOptions: getDumping,
  },
  concrete: {
    label: "Concrete",
    icon: Beaker,
    bgColor: "bg-orange-50",
    defaultUnit: "Yards",
    units: ["Yards"],
    fetchOptions: getMixDesigns,
  },
  custom_labor: {
    label: "Custom Labor",
    icon: Users,
    bgColor: "bg-blue-100",
    defaultUnit: "Hours",
    units: ["Hours"],
    isCustom: true,
  },
  custom_material: {
    label: "Custom Material",
    icon: Cube,
    bgColor: "bg-green-100",
    defaultUnit: "Each",
    units: getUnits,
    isCustom: true,
  },
  custom_equipment: {
    label: "Custom Equipment",
    icon: Cog,
    bgColor: "bg-yellow-100",
    defaultUnit: "Hours",
    units: ["Hours"],
    isCustom: true,
  },
};

// Column configuration for each line item type
export const COLUMN_CONFIG = {
  labor: { quantity: false, rtHours: true, otHours: true, priceOT: true },
  material: {
    quantity: true,
    rtHours: false,
    otHours: false,
    priceOT: false,
  },
  equipment: { quantity: true, rtHours: true, otHours: true, priceOT: true },
  concrete: {
    quantity: true,
    rtHours: false,
    otHours: false,
    priceOT: false,
  },
  subcontractors: {
    quantity: true,
    rtHours: false,
    otHours: false,
    priceOT: false,
  },
  dumping: { quantity: true, rtHours: false, otHours: false, priceOT: false },
  custom_labor: {
    quantity: false,
    rtHours: true,
    otHours: true,
    priceOT: true,
  },
  custom_material: {
    quantity: true,
    rtHours: false,
    otHours: false,
    priceOT: false,
  },
  custom_equipment: {
    quantity: true,
    rtHours: true,
    otHours: true,
    priceOT: true,
  },
};

// Admin link mapping for item types
export const ADMIN_LINKS = {
  labor: "/admin/core/customuser",
  material: "/admin/details/asset",
  equipment: "/admin/details/asset",
  subcontractors: "/admin/details/subcontractor",
  dumping: "/admin/details/dumpingsupplier",
  concrete: "/admin/fieldapps/mixdesign",
};

// Column sizing configuration for table header and cells
export const COL_SIZING = {
  report: {
    option: "w-[50%]",
    quantity: "w-[10%]",
    rtHours: "w-[10%]",
    otHours: "w-[10%]",
    unit: "w-[10%]",
    actions: "w-[10%]",
  },
  pricing: {
    option: "w-[36%]",
    quantity: "w-[8%]",
    rtHours: "w-[8%]",
    otHours: "w-[8%]",
    unit: "w-[8%]",
    pricePerUnitRT: "w-[8%]",
    pricePerUnitOT: "w-[8%]",
    total: "w-[8%]",
    actions: "w-[8%]",
  },
};

// Category grouping configuration for displaying items in sections
export const CATEGORIES = {
  labor: {
    label: "Labor",
    icon: Users,
    types: ["labor", "custom_labor"],
    headerBgColor: "bg-blue-50",
  },
  material: {
    label: "Material",
    icon: Cube,
    types: ["material", "custom_material"],
    headerBgColor: "bg-green-50",
  },
  equipment: {
    label: "Equipment",
    icon: Cog,
    types: ["equipment", "custom_equipment"],
    headerBgColor: "bg-yellow-50",
  },
  subcontractors: {
    label: "Subcontractors",
    icon: Truck,
    types: ["subcontractors"],
    headerBgColor: "bg-purple-50",
  },
  dumping: {
    label: "Dumping",
    icon: Trash,
    types: ["dumping"],
    headerBgColor: "bg-amber-50",
  },
  concrete: {
    label: "Concrete",
    icon: Beaker,
    types: ["concrete"],
    headerBgColor: "bg-orange-50",
  },
};
